import Big from 'big.js'

// Match cf-server: calculate in decimal, then round monetary results half up.
const asPrice = value => {
  const cents = value.times(100).round(0, 1)
  if (!Number.isSafeInteger(Number(cents.toString()))) {
    throw new Error('Price exceeds safe integer range')
  }
  return Number(cents.div(100).toString())
}

export const currencyPrice = value => asPrice(new Big(value))
export const isValidPrice = value => {
  try {
    currencyPrice(value)
    return true
  } catch {
    return false
  }
}
export const multiplyPrice = (price, multiplier) => asPrice(new Big(price).times(multiplier))

export const normalizeProductPrice = product => (
  Object.prototype.hasOwnProperty.call(product, 'price')
    ? { ...product, price: currencyPrice(product.price) }
    : product
)

export const normalizeModifierPrices = modifier => (
  Array.isArray(modifier.choices)
    ? { ...modifier, choices: modifier.choices.map(normalizeProductPrice) }
    : modifier
)
